export enum PasswordType {
  Current,
  New,
  Confirm,
}
